function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icons/star",
    d: "m15.622 17.657-5.182-.5-2.059-5.017a.408.408 0 0 0-.763 0L5.56 17.153l-5.182.5a.441.441 0 0 0-.236.761l3.91 3.6-1.145 5.33a.42.42 0 0 0 .617.47L8 25.028l4.475 2.787a.42.42 0 0 0 .617-.47l-1.144-5.325 3.91-3.6a.441.441 0 0 0-.236-.763z",
    transform: "translate(0 -11.877)",
    style: {
      fill: "#6b7de5"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icons_star.cec505d6bbb8f0e5a920543d9e71d06b.svg";